import { api } from './client';

// ── Categories ──────────────────────────────────────────────────────────────

export function listCategories() {
  return api.get('/establishments/me/categories');
}

export function createCategory(data) {
  return api.post('/establishments/me/categories', data);
}

export function updateCategory(categoryId, data) {
  return api.patch(`/establishments/me/categories/${categoryId}`, data);
}

export function deleteCategory(categoryId) {
  return api.delete(`/establishments/me/categories/${categoryId}`);
}

// ── Products ────────────────────────────────────────────────────────────────

export function listProducts() {
  return api.get('/establishments/me/products');
}

export function createProduct(data) {
  return api.post('/establishments/me/products', data);
}

export function updateProduct(productId, data) {
  return api.patch(`/establishments/me/products/${productId}`, data);
}

export function deleteProduct(productId) {
  return api.delete(`/establishments/me/products/${productId}`);
}

// ── Variants ────────────────────────────────────────────────────────────────

export function createVariant(productId, data) {
  return api.post(`/establishments/me/products/${productId}/variants`, data);
}

export function updateVariant(productId, variantId, data) {
  return api.patch(`/establishments/me/products/${productId}/variants/${variantId}`, data);
}

export function deleteVariant(productId, variantId) {
  return api.delete(`/establishments/me/products/${productId}/variants/${variantId}`);
}

// ── Category add-ons ────────────────────────────────────────────────────────

export function createCategoryAddon(categoryId, data) {
  return api.post(`/establishments/me/categories/${categoryId}/addons`, data);
}

export function updateCategoryAddon(categoryId, addonId, data) {
  return api.patch(`/establishments/me/categories/${categoryId}/addons/${addonId}`, data);
}

export function deleteCategoryAddon(categoryId, addonId) {
  return api.delete(`/establishments/me/categories/${categoryId}/addons/${addonId}`);
}

// ── Product add-ons ─────────────────────────────────────────────────────────

export function createProductAddon(productId, data) {
  return api.post(`/establishments/me/products/${productId}/addons`, data);
}

export function updateProductAddon(productId, addonId, data) {
  return api.patch(`/establishments/me/products/${productId}/addons/${addonId}`, data);
}

export function deleteProductAddon(productId, addonId) {
  return api.delete(`/establishments/me/products/${productId}/addons/${addonId}`);
}
